import styled from 'styled-components';
import { HeadingStyledProps } from './InfoTitle.types';

const InfoTitle = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Icon = styled.div`
  flex: 0 0 auto;
  margin-right: ${({ theme }) => theme.spacing.M16};
  align-self: center;
`;

const Content = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
`;

const Heading = styled.div<HeadingStyledProps>`
  color: inherit;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;

  max-width: 100%;
  ${({ reverse }) => (reverse ? 'order: 2;' : '')};
`;

const SubHeading = styled.div<{ color?: string }>`
  color: ${(props) => props.color || 'inherit'};
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
`;

export { InfoTitle, Icon, Content, Heading, SubHeading };
